import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P20-E1',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e1-p20.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page20/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/2.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/tieude-e1-p20.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/5.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/noodles.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/7.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/pizza.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/9.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/milkshake.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/12.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/salad.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/14.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/noodles.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/16.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/pizza.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/18.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/milkshake.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/20.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/chicken.mp3" },
        { url: 'img/FriendsPlus/Page20/E1/21.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E1/22.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P20-E2',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e2-p20.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page20/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/2.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/tieude-e2-p20.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/5.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/noodles.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/7.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/pizza.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/12.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/salad.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/14.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/noodles.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/16.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/pizza.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/18.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/milkshake.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/20.jpg', audioUrl: "img/FriendsPlus/Page20/Audio/chicken.mp3" },
        { url: 'img/FriendsPlus/Page20/E2/21.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E2/22.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P20-E3',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e3-p20.mp3',
    video: 'Videos/e3.p20.mp4',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page20/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/tieude-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/6.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh1-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/8.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh2-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page20/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/12.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh3-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/14.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh4-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page20/E3/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page20/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/18.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh5-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/20.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh6-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/21.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page20/E3/22.jpg' },
      ],
    ],
  },
}

export default json;